import { axiosInstance } from '../axios';

const defaultRequestedSize = 30;
const defaultRequestedPage = 0;
const defaultRequestedObject = { page: defaultRequestedPage, size: defaultRequestedSize };
const getAllApi = {
  getOrders({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/ordersv2?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getOrdersWithSearch({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/ordersv2/search?size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPreviousExportsByType(type) {
    const url = `/import-export-manager/export?exportType=${type}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getMarketplaceOrders({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/marketplaces-orders?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getStores({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/stores?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSubscriptions({
    page = defaultRequestedPage,
    format = 'short',
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/subscription-manager/subscriptions?format=${format}&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSubscriptionMonitoring({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters = '',
    sortParams,
  } = defaultRequestedObject) {
    let url = `/sub-monitoring/api/states?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSubscriptionMonitoringReport() {
    const url = `/sub-monitoring/api/reports/states`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getProducts({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
    parentId = null,
    notAddParentId,
    format = 'short',
  } = defaultRequestedObject) {
    let url = `/products?format=${format}&size=${size}&page=${page}`;

    if (!notAddParentId) {
      url += `&parentId=${parentId}`;
    }

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getCatalogs({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/catalogs?format=short&asc&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getCustomFieldsDefinition({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/products/customFieldsDefinition?size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getIdentities({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/iam/identities?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPrivileges({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/iam/privileges?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getRoles({
    page = defaultRequestedPage,
    filters,
    size = defaultRequestedSize,
    sortParams,
  } = defaultRequestedObject) {
    let url = `iam/roles?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getMetaRoles({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `iam/meta-roles?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  /**
   * function get filtered and sorted customers
   * @param {*} {page, filters, size, sortParams}
   * we get string with filters like &features=features.sgOrdersManagement,features.productManagement
   * it doens't work for filtering,
   * because we need send &features.sgOrdersManagement=true&features.productManagement=true
   * @returns
   */
  getCustomers({
    page = 0,
    filters,
    size = defaultRequestedSize,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/customers?format=short&size=${size}&page=${page}`;

    if (sortParams?.value && sortParams?.type) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      const params = new URLSearchParams();

      filters.split('&').forEach((param) => {
        if (!param) return;

        const [key, value] = param.split('=');

        // match case for object=object.key[=value]
        if (key && value && value.startsWith(`${key}.`)) {
          value.split(',').forEach((nestedParam) => {
            // regExp for object.key[=value]
            const match = nestedParam.match(/^([^\.]+)\.([^=]+)(?:=(.*))?$/);

            if (match && match[1] === key) {
              const nestedKey = match[2];
              const nestedValue = match[3] || 'true'; // set 'true' as default value
              params.append(`${key}.${nestedKey}`, nestedValue);
            }
          });
        } else if (key && value !== undefined) {
          params.append(key, value);
        }
      });
      url += `&${params.toString()}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCustomersByName(name = '') {
    const encodedName = encodeURIComponent(name);
    const url = `/customers/public?name=*${encodedName}*`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPublicCustomers({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  }) {
    let url = '/customers/public?format=short';

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    url += `&size=${size}&page=${page}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCampaigns({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = '/marketing-campaign/campaigns?format=short&with-count=false&with-secondary=true';

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    url += `&size=${size}&page=${page}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getRecommendations({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/product-recommendations?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDiscounts({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/discounts?format=short&asc&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getPaymentMethodsOptions() {
    const url = '/payment-proxy/available-payment-types';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPaymentMethodsOptionsByCustomerId(customerId) {
    const url = `/payment-proxy/available-payment-types?customerId=${customerId}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPaymentConfigOptions() {
    const url = '/payment-proxy/service/config';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSellingStoreOptions(customerId) {
    const url = `/stores?format=short&customerId=${customerId}&size=200&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getFulfillmentsOptions() {
    const url = '/fulfillments/partners?size=30&page=0';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSubscriptionsOptions() {
    const url = '/subscription-manager/models?format=short&size=30&page=0';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDesignsTranslations({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/designs/i18ns?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDesignsFonts({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/designs/fonts?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDesignsThemes({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/designs/themes?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getMarkups() {
    const url = '/designs/markup';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDesignsLayouts({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/designs/layouts?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getConditionsOfAvailability() {
    const url = '/iam/roles/availableAvailabilityConditions';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCountryOptions() {
    const url = '/referential-manager/country?size=400&sort=name,asc';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLocaleOptions() {
    const url = '/referential-manager/locale?size=400&sort=code,asc';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLocales({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/referential-manager/locale?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getCurrency({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/referential-manager/currency?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSubsidiary({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/subsidiary-manager/subsidiaries?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getFullSubsidiary({ size = defaultRequestedSize, filters, sortParams } = defaultRequestedObject) {
    let url = `/subsidiary-manager/public?target=subsidiaryId,name&size=${size}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getCountry({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/referential-manager/country?size=${size}&page=${page}&withRegion=true`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getEventsOptions() {
    const url = '/notification/definitions?format=short&size=0&page=0';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getMarketingPrices({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/prices?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getPriceFunctions({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/products/price-functions?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getNotifications({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/notification/receivers?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getNotificationDefinition({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/notification/definitions?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getNotificationsHistory({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/notification/notifications?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getLicenses({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
  } = defaultRequestedObject) {
    let url = `/license-manager/licenses?format=short&size=${size}&page=${page}`;

    if (filters) {
      const adjustFilters = filters.replace(',', '&status=');
      url += adjustFilters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getCarts({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/carts?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getEndUsersGroups({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/endusers/groups?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getOnboardingList({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/onboarding?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },

  getAutoFulfillments({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/fulfillments/partners?size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getManualFulfillments({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/license-keys-provider/packages?size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getManualFulfillmentsForProduct(productId, publisherProductId, publisherId) {
    const url = `/license-keys-provider/packages?format=short&nexwayProductId=${productId}&publisherProductId=${publisherProductId}&publisherId=${publisherId}&page=${defaultRequestedPage}&size=${defaultRequestedSize}`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLicenseProviderDefinitions({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/license-manager/license-provider-definitions?size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getEndUsers({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/endusers?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getDiscountsUsages({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/discounts/usages?format=short&page=${page}&size=${size}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getGroupsOptionsByCustomerId(customerId) {
    const url = `/endusers/groups?customerId=${customerId}&size=30&page=0`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getResellers({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
    type,
  }) {
    let url = `/endusers?format=short&type=${type}&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getAbandoned({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `campaigns/abandonedcarts?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getLicenseExpirationCampaigns({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `campaigns/license-expiration-campaigns?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getEmailBuilder({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/email-builder/template-definitions?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getRemittables({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/remittables?format=short&size=${size}&page=${page}`;

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getAudits({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/audits/auditItems?format=short&size=${size}&page=${page}&with-count=false&with-secondary=true`;

    if (sortParams?.value) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getInvoiceTranslations({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/designs/legali18ns?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getRequest(
    url_,
    {
      page = defaultRequestedPage,
      size = defaultRequestedSize,
      filters,
      sortParams,
    } = defaultRequestedObject,
    extraParams,
  ) {
    let url = `${url_}?format=short&size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    if (extraParams) {
      url += `&${extraParams}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getServiceConfig(name) {
    const url = `/${name}/service/config/clear`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getRealms({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
  } = defaultRequestedObject) {
    let url = `/iam/realms?format=short&size=${size}&page=${page}`;

    if (filters) {
      const adjustFilters = filters.replace(',', '&status=');
      url += adjustFilters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getQR() {
    const url = '/iam/2fa/get-qr-code';

    return axiosInstance({
      method: 'get',
      url,
      headers: {
        'Content-Type': 'application/octet-stream',
        accept: undefined,
      },
      responseType: 'blob',
    });
  },
  getLegalEntitiesOptions() {
    const url = '/referential-manager/legal-entity';

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getSecretKeys(identityId) {
    const url = `/iam/identities/${identityId}/secretToken`;

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getTnc({
    page = defaultRequestedPage,
    size = defaultRequestedSize,
    filters,
    sortParams,
  } = defaultRequestedObject) {
    let url = `/tandcs/templates?size=${size}&page=${page}`;

    if (filters) {
      url += filters;
    }

    if (sortParams) {
      url += `&sort=${sortParams.value},${sortParams.type}`;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
  getInvoicesExport(filters) {
    let url = `/invoices/invoice-jobs`;

    if (filters) {
      url += filters;
    }

    return axiosInstance({
      method: 'get',
      url,
    });
  },
};
export default getAllApi;
